module.exports = "/images/icon_ourstory_1.png?bb294f2e97194ff2888d647435c561d9";